import { observer } from 'mobx-react';
import { LoanDetailsCard } from '../fixFlip/loanDetailsCard';
import { LoanDetailsCardProps } from '../fixFlip/summaryStep';
import { formatPercentage } from '@roc/ui/utils';

export const GroundUpLoanDetailsCard = observer(
  ({ store }: LoanDetailsCardProps) => {
    return <_GroundUpLoanDetailsCard store={store} showAccordion={true} />;
  }
);
export const GroundUpLoanDetailsCardNoAccordion = observer(
  ({ store }: LoanDetailsCardProps) => {
    return <_GroundUpLoanDetailsCard store={store} showAccordion={false} />;
  }
);

const _GroundUpLoanDetailsCard = observer(
  ({
    store,
    showAccordion,
  }: LoanDetailsCardProps & { showAccordion: boolean }) => {
    const calculatedFields = store.loanEconomicsStore.calculateFields();

    const ltcPurchasePricePercentage = formatPercentage(
      calculatedFields.loanToCost
    );
    const ltcConstructionBudgetHoldbackPercentage = formatPercentage(
      calculatedFields.constructionReserve
    );
    const ARLTV = formatPercentage(calculatedFields.afterRepairLTV);

    return (
      <LoanDetailsCard
        store={store}
        keyRatios={`${ltcPurchasePricePercentage} / ${ltcConstructionBudgetHoldbackPercentage} / ${ARLTV}`}
        showAccordion={showAccordion}
        keyRatiosTooltip={
          'LTC Purchase Price / LTC Construction Budget (Holdback) / ARLTV'
        }
      />
    );
  }
);
